/**
 * NOTE! These regexes should not be used for input validation, only for data scrubbing since they are intentionally made broad in order to catch most of the reasonable formats (but not all).
 */

/**
 * Email Regular Expression that matches most common (and reasonable) email formats.
 * See: https://colinhacks.com/essays/reasonable-email-regex
 */
export const REGEX_CONTAINS_EMAIL =
  /(?!\.)(?!.*\.\.)([a-z0-9_'+\-.]*)[a-z0-9_'+-]@([a-z0-9][a-z0-9-]*\.)+[a-z]{2,}/g;

// TODO: Once iOS 16.3 no longer needs to be supported `(?<![-a-zA-Z])` can be prepended to the reges patterns,
// which should further reduce the risk of User IDs and correlation IDs getting scrubbed
/**
 * Phone number Regular Expression that matches Swedish phone numbers with and without country code and various separators.
 */
export const REGEX_CONTAINS_SWEDISH_MOBILE_PHONE =
  /(?:\+46\s?7\d{1})([-\s]?\d{3})([-\s]?\d{2})([-\s]?\d{2})(?![-a-zA-Z0-9])|07\d{1}([-\s]?\d{3})([-\s]?\d{2})([-\s]?\d{2})(?![-a-zA-Z0-9])/g;
/**
 * Phone number Regular Expression that matches Finnish phone numbers with and without country code and various separators.
 */
export const REGEX_CONTAINS_FINNISH_MOBILE_PHONE =
  /(?:\+358\s?\d{2})([-\s]?\d{3})([-\s]?\d{2})([-\s]?\d{2})(?![-a-zA-Z0-9])|(04|05)\d{1}([-\s]?\d{3})([-\s]?\d{2})([-\s]?\d{2})(?![-a-zA-Z0-9])/g;

/**
 * Swedish Social Security Number (SSN) Regular Expression that matches both with and without a hyphen.
 * Supports both 10-digit (YYMMDD-XXXX) and 12-digit (YYYYMMDD-XXXX) formats.
 * Uses word boundaries (\b) to prevent matching when preceded or followed by letters or digits.
 */
export const REGEX_CONTAINS_SWEDISH_SSN =
  /\b(?:19|20)?(\d{2})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])(-?\d{4})\b/g;
/**
 * Finnish Social Security Number (SSN) Regular Expression.
 */
export const REGEX_CONTAINS_FINNISH_SSN =
  /(\d{2})(\d{2})(\d{2})([+\-AYXWVUBCDEF])(\d{3})([0-9A-Y])(?![-a-zA-Z0-9])/g;
